import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import timeUtils from '@/utils/time.js';
import FlipUnitCountainerCopy from './Count/FlipUnitCountainercopy';
import FlipUnitContainer from './Count/FlipUnitCountainer';
export default {
  // mounted () {
  //   setTimeout( () => {
  //     this.hide()
  //   }, 3000 )
  //   setTimeout( () => {
  //     this.show()
  //   }, 5000 )
  // },
  components: {
    FlipUnitContainer: FlipUnitContainer,
    FlipUnitCountainerCopy: FlipUnitCountainerCopy
  },
  data: function data() {
    return {
      days: 0,
      daysShuffle: true,
      hours: 0,
      hoursShuffle: true,
      minutes: 0,
      minutesShuffle: true,
      seconds: 0,
      secondsShuffle: true,
      reportTime: 0,
      reportTime2: 0,
      reportTime3: 0,
      // 连续回拨累计（命中三次再上报）
      rollBackList: [],
      rollBackList2: [],
      rollBackList3: []
    };
  },
  props: {
    onSaleTime: Number,
    now: Number,
    countDownTestUser: Boolean,
    mode: {
      type: String,
      default: 'normal'
    }
  },
  computed: {
    onSaleTimeInfo: function onSaleTimeInfo() {
      var onSaleTime = this.onSaleTime;
      var _timeUtils$formatOnSa = timeUtils.formatOnSaleTime(onSaleTime),
        onSaleTimeInfo = _timeUtils$formatOnSa.onSaleTimeInfo;
      return onSaleTimeInfo;
    },
    leftTimeInfo: function leftTimeInfo() {
      var now = this.now,
        onSaleTime = this.onSaleTime;
      var leftTimeInfo = timeUtils.fomatRemainText(now, onSaleTime);
      return leftTimeInfo;
    }
  },
  watch: {
    now: function now(value, oldValue) {
      if (value < oldValue) {
        if (this.reportTime3 <= 3) {
          this.reportTime3++;
          this.rollBackList3.push({
            newValue: value,
            oldValue: oldValue
          });
          if (this.reportTime3 === 3) {
            this.reportError('项目详情-bomb-倒计时回拨3', {
              list: this.rollBackList3
            });
          }
        }
      }
      this.updateTimeByNow(value);
      this.updateTime();
    }
  },
  created: function created() {
    var _this$getNowTime = this.getNowTime(),
      days = _this$getNowTime.days,
      hours = _this$getNowTime.hours,
      minutes = _this$getNowTime.minutes,
      seconds = _this$getNowTime.seconds;
    this.days = days;
    this.hours = hours;
    this.minutes = minutes;
    this.seconds = seconds;
  },
  methods: {
    getNowTime: function getNowTime(currentNow) {
      var now = currentNow || this.now;
      var onSaleTime = this.onSaleTime;
      var leftTime = onSaleTime - now;
      var leftDays = timeUtils.getLeftDays(leftTime);
      var leftHours = timeUtils.getLeftHours(leftTime);
      var leftMinutes = timeUtils.getLeftMinutes(leftTime);
      var leftSeconds = timeUtils.getLeftSeconds(leftTime);
      return {
        days: leftDays,
        hours: leftHours,
        minutes: leftMinutes,
        seconds: leftSeconds
      };
    },
    // 异常上报
    reportError: function reportError(name, error) {
      window.Owl && window.Owl.addError({
        name: name,
        msg: {
          error: {
            message: error.message,
            stack: error.stack || error
          }
        }
      });
    },
    updateTimeByNow: function updateTimeByNow(now) {
      try {
        var _this$getNowTime2 = this.getNowTime(now),
          seconds = _this$getNowTime2.seconds,
          minutes = _this$getNowTime2.minutes;
        if (minutes === this.minutes) {
          if (seconds > this.seconds) {
            if (this.reportTime2 <= 3) {
              this.reportTime2++;
              this.rollBackList2.push({
                seconds: seconds,
                thisSeconds: this.seconds,
                now: now,
                ts: Date.now()
              });
              if (this.reportTime2 === 3) {
                this.reportError('项目详情-bomb-倒计时回拨2', {
                  list: this.rollBackList2
                });
              }
            }
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    updateTime: function updateTime() {
      var _this$getNowTime3 = this.getNowTime(),
        days = _this$getNowTime3.days,
        hours = _this$getNowTime3.hours,
        minutes = _this$getNowTime3.minutes,
        seconds = _this$getNowTime3.seconds;
      // on days change, update days and shuffle state
      if (days !== this.days) {
        this.days = days;
        this.daysShuffle = !this.daysShuffle;
      }
      // on hour chanage, update hours and shuffle state
      if (hours !== this.hours) {
        this.hours = hours;
        this.hoursShuffle = !this.hoursShuffle;
      }
      try {
        if (minutes === this.minutes) {
          if (seconds > this.seconds) {
            if (this.reportTime <= 3) {
              this.reportTime++;
              this.rollBackList.push({
                seconds: seconds,
                thisSeconds: this.seconds,
                now: this.now,
                ts: Date.now()
              });
              if (this.reportTime === 3) {
                this.reportError('项目详情-bomb-倒计时回拨', {
                  list: this.rollBackList
                });
              }
            }
          }
        }
      } catch (e) {
        console.log(e);
      }
      // on minute chanage, update minutes and shuffle state
      if (minutes !== this.minutes) {
        this.minutes = minutes;
        this.minutesShuffle = !this.minutesShuffle;
      }
      // on second chanage, update seconds and shuffle state
      if (seconds !== this.seconds) {
        this.seconds = seconds;
        this.secondsShuffle = !this.secondsShuffle;
      }
    },
    hide: function hide() {
      var bomb = document.getElementById('bomb-component');
      bomb.animate([{
        top: 0
      }, {
        top: '150%'
      }], {
        fill: 'forwards',
        duration: 800
      });
    },
    show: function show() {
      var bomb = document.getElementById('bomb-component');
      bomb.animate([{
        top: '150%'
      }, {
        top: 0
      }], {
        fill: 'forwards',
        duration: 800
      });
    }
  }
};